<template>
    <div>
        <select class="opui-form-control" :id="id" :name="name" :disabled="disabled" :required="required">
            <slot></slot>
        </select>
    </div>
</template>

<script>
import '../../../../../node_modules/select2/dist/js/select2.full'
import '../../../../../node_modules/select2/dist/css/select2.min.css'

export default {
    name: 'Select2',
    data() {
        return {
            select2: null
        };
    },
    emits: ['update:modelValue', 'select', 'options'],
    props: {
        modelValue:  [String, Array],
        id:          { type: String, default: '' },
        name:        { type: String, default: '' },
        placeholder: { type: String, default: '' },
        options:     { type: Array, default: () => [] },
        disabled:    { type: Boolean, default: false },
        required:    { type: Boolean, default: false },
        settings:    { type: Object, default: () => {} },
        ajaxUrl:     null,
    },
    watch: {
        options: {
            handler(val) {
                this.$emit('options', val)
                this.setOption(val)
            },
            deep: true
        },
        modelValue: {
            handler(val) {
                this.setValue(val)
            },
            deep: true
        },
        ajaxUrl: {
            handler(val) {
                this.setOption({
                    ajax: { url: val }
                })
            }
        }
    },
    methods: {
        setOption(val = []) {
            this.select2.empty()
            this.select2.select2({
                dropdownCssClass: "opui-select2-dropdown",
                placeholder: this.placeholder,
                minimumInputLength: 0,
                multiple: false,
                ...this.settings,
                data: val,
            });
            this.setValue(this.modelValue)
        },
        setValue(val) {
            if (val instanceof Array) {
                this.select2.val([...val])
            } else {
                this.select2.val([val])
            }
            this.select2.trigger('change')
        }
    },
    mounted() {
        let settings = {
            dropdownCssClass: "opui-select2-dropdown",
            placeholder: this.placeholder,
            minimumInputLength: 0,
            multiple: false,
            // minimumResultsForSearch: 1,
            ...this.settings,
            data: this.options,
            escapeMarkup: function (m) {
                return m;
            },
            templateSelection: function (option) {
                if (option.element && option.element.dataset && option.element.dataset.icon) {
                    return '<span><i class="op3-icon ' + option.element.dataset.icon + '" style="position: relative; top: 2px; margin-right: 4px;"></i> ' + option.text + '</span>';
                } else if (option.icon) {
                    return '<span><i class="op3-icon '+option.icon+'" style="position: relative; top: 2px; margin-right: 4px;"></i> ' + option.text + '</span>';
                } else {
                    return option.text;
                }
            },
            templateResult: function(optionElement) {
                if (! optionElement.id) {
                    return optionElement.text;
                }

                if (optionElement.badge_title) {
                    return jQuery('<span><span class="opui-badge opui-badge-secondary">' + optionElement.badge_title + '</span> ' + optionElement.text  + '</span>');
                }

                if (optionElement.icon) {
                    return jQuery('<span><i class="op3-icon '+optionElement.icon+'" style="position: relative; top: 2px; margin-right: 4px;"></i> ' + optionElement.text + '</span>');
                }

                return optionElement.text;
            }
        }

        // Check ajax
        if (this.ajaxUrl || (settings.ajax && settings.ajax.url)) {
            if (! settings.ajax && this.ajaxUrl) {
                settings.ajax = { url: this.ajaxUrl }
            }
            settings.ajax.headers = { "X-WP-Nonce": window.OptimizeFlow.nonce }
        }
        // console.log("S2 SETTINGS", settings);

        this.select2 = jQuery(this.$el)
            .find('select')
            .select2(settings)
            .on('select2:select select2:unselect', ev => {
                this.$emit('update:modelValue', this.select2.val())
                this.$emit('select', ev['params']['data'])
            })
            .on('select2:open', ev => {
                document.querySelector('.select2-search__field').focus()
            })
        this.setValue(this.modelValue)
    },
    beforeUnmount() {
        this.select2.select2('destroy')
    }
}
</script>
